import { OpinionInstanceFieldType } from './types';

export const getShouldDisplayInlineChangesType = (type: OpinionInstanceFieldType) => [
    OpinionInstanceFieldType.DROPDOWN,
    OpinionInstanceFieldType.ENTITY,
    OpinionInstanceFieldType.TEXT,
    OpinionInstanceFieldType.LONGTEXT,
    OpinionInstanceFieldType.DATE
].includes(type);
